import { Client } from '../../../types/client';
import { useAuth } from '../../authentication/hooks/useAuth';

export function useClient(): Client {
  const client = useAuth().client;

  if (!client) {
    throw new Error('No client found!');
  }

  return client;
}
